import { Selector } from '@granlupo/api-client/generated/content/zeus'
import type { FacetFilter } from '../backend/typesense/FacetFilter'
import { serializeFilter } from './serializeFilter'

export function createEmptyProductFilter(): FacetFilter {
	return {}
}

export const regionsMap = {
	onlyCzechBrands: ['ČR'],
	onlyEuropeanBrands: ['Evropa', 'ČR', 'USA/Kanada/Evropa'],
	onlyAmericanBrands: ['USA/Kanada', 'USA/Kanada/Evropa'],
}

export const ItemSubCategory_isFlavorFilter = Selector('ItemSubCategoryWhere')({
	isFlavorCategory: { eq: true },
})

export async function productFilterToUrl(filter: FacetFilter, baseUrl?: string | null) {
	const url = new URL(baseUrl ?? '/test/filter', 'http://localhost')
	const serialized = serializeFilter(filter)
	if (serialized) {
		url.searchParams.set('filter', serialized)
	}
	return url.toString().replace(/^http:\/\/localhost/, '')
}
